// src/components/layout/BottomNavigation.js
import React from 'react';
import { HomeIcon, SearchIcon, CalendarIcon, HeartIcon, UserIcon } from '../common/Icons';

const NavButton = ({ icon, label, isActive, onClick, badge }) => {
  return (
    <button 
      className="flex flex-col items-center justify-center relative"
      onClick={onClick}
    >
      <div className={`mb-1 ${isActive ? 'text-blue-600' : 'text-gray-500'}`}>
        {icon}
        {badge && (
          <div className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
            {badge}
          </div>
        )}
      </div>
      <span className={`text-xs ${isActive ? 'text-blue-600' : 'text-gray-500'}`}>
        {label}
      </span>
    </button>
  );
};

const BottomNavigation = ({ currentScreen, navigateTo }) => {
  return (
    <div className="flex justify-around items-center py-2 bg-white border-t border-gray-200">
      <NavButton 
        icon={<HomeIcon size={24} />} 
        label="Acasă" 
        isActive={currentScreen === 'home'} 
        onClick={() => navigateTo('home')} 
      />
      <NavButton 
        icon={<SearchIcon size={24} />} 
        label="Descoperă" 
        isActive={currentScreen === 'search'} 
        onClick={() => navigateTo('search')} 
      />
      <NavButton 
        icon={<CalendarIcon size={24} />} 
        label="Programări" 
        isActive={currentScreen === 'appointments'} 
        onClick={() => navigateTo('appointments')} 
      />
      <NavButton 
        icon={<HeartIcon size={24} />} 
        label="Favorite" 
        isActive={currentScreen === 'favorites'} 
        onClick={() => navigateTo('favorites')} 
      />
      <NavButton 
        icon={<UserIcon size={24} />} 
        label="Profil" 
        isActive={currentScreen === 'profile'} 
        onClick={() => navigateTo('profile')} 
        badge={3}
      />
    </div>
  );
};

export default BottomNavigation;